import styled from "styled-components/macro";

export const EditCreatorPageWrapperStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  .edit-creator-details {
  }

  .header-wrapper {
    display: flex;
    align-items: center;

    .go-back-btn {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;

      border-radius: 50%;
      cursor: pointer;

      &:hover {
        background-color: var(--Neutral-4);
      }
    }

    .title {
      color: var(--Neutral-100);
      font-size: 24px;
      font-weight: 600;
      line-height: 32px;
      letter-spacing: -0.048px;
      padding: 4px;
    }

    .verified-badge {
      margin: 8px;
      display: flex;
      align-items: center;
      gap: 4px;
      padding: 4px 8px 4px 5px;
      border-radius: 4px;
      background: linear-gradient(
        0deg,
        rgba(140, 99, 204, 0.2) 0%,
        rgba(140, 99, 204, 0.2) 100%
      );

      .badge-text {
        color: #8c63cc;
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: -0.18px;
      }
    }
  }
`;

export const PageScrollWrapperStyles = styled.div`
  padding: 0 0 175px 0;
  overflow-y: auto;
  height: calc(100vh - 176px);

  /* custom scrollbar */
  &::-webkit-scrollbar {
    /* display: none; */
    height: 8px;
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: var(--Neutral-300);
    border: 1px solid transparent;
    background-clip: content-box;
  }
`;

// needed stickyness so separate file created
export const FormFooterStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 16px;
  background-color: white;

  button {
    padding: 10px 20px;
  }
`;
export const CreatorPlatformsWrapperStyles = styled.div`
  display: flex;
  padding: 2px;
  flex-direction: column;
  align-items: stretch;

  border-radius: 12px;
  background: linear-gradient(
    0deg,
    rgba(245, 159, 0, 0.08) 0%,
    rgba(245, 159, 0, 0.08) 100%
  );

  .main-content {
    background: #fff;
    border-radius: 10px;
    background: #fff;

    display: flex;
    padding: 12px 8px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;

    .platform-list {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 16px;

      .platform-list-item {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 8px;

        .icon {
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 8px;
          background-color: var(--Neutral-10);
        }

        .detail {
          flex: 1;
          strong {
            color: var(--Neutral-60);
            font-size: 12px;
            font-weight: 500;
            line-height: 16px;
            letter-spacing: -0.18px;
          }
          p {
            margin-top: 4px;
            color: var(--Neutral-100);
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
            letter-spacing: -0.14px;
            width: 240px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }

  .note {
    display: flex;
    flex-direction: column;
    padding: 8px 12px;

    strong {
      color: var(--warning-100);
      font-size: 12px;
      font-weight: 500;
      line-height: 16px;
      letter-spacing: -0.18px;
    }
    p {
      color: var(--Neutral-80);
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      letter-spacing: -0.12px;
    }
  }
`;

export const EditCreatorFormWrapperStyles = styled.section`
  .form-header-wrapper {
    padding: 8px;
    display: flex;
    align-items: center;

    .title {
      color: var(--Neutral-100);
      font-size: 20px;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: -0.3px;
      padding: 8px 0;
    }
  }

  .form-content-wrapper {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 24px;

    .row-group {
      display: flex;
      align-items: stretch;
      gap: 24px;

      .column-group {
        display: flex;
        flex-direction: column;
        gap: 24px;
        flex: 1;
      }
    }

    /* radio input ui styles */
    .radio-input-wrapper {
      display: flex;
      flex-direction: column;
      gap: 4px;

      .radio-input-group {
        display: flex;
        align-items: center;
        gap: 12px 24px;
        flex-wrap: wrap;
        padding: 4px 0;
      }

      .radio-input-item {
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;

        color: var(--Neutral-80);
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: -0.14px;

        input[type="radio"] {
          cursor: pointer;
          accent-color: var(--Neutral-80);

          &:disabled {
            cursor: not-allowed;
          }
        }
      }
    }
    /* radio input ui styles */

    /* custom fields */
    .managed-by-wrapper {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .checkbox-input-item {
        width: fit-content;
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;

        color: var(--Neutral-80);
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: -0.14px;

        input[type="checkbox"] {
          cursor: pointer;
          accent-color: var(--Neutral-80);

          &:disabled {
            cursor: not-allowed;
          }
        }
      }
    }

    /* creator platform section */
    .hide-profile {
      width: fit-content;
      display: flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;

      color: var(--Neutral-80);
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.14px;
    }
  }
`;
